/**
 * 不同题型的字段
 */

// 全部都有的字段
let basics = [
  'stepId',
  'title',
  'titleAlias',
  'type',
  'images',
  'desc',
  'descPrefix',
  'default_jump',
  'delay',
  'guideText',
  'guideVideo',
  'guideAudio',
  'forceGuideVideo',
  'forceGuideAudio',
  'auditText',
  'keyin_ids',
  'ondutyCheck',
  'throughRecordKeyQuestion',
  'allow_screen_capture',
  'allow_media_download',
]
// 多次重用组合
let reusing = [
  'referStepId',
  'referIds',
  'needPhoto',
  'forceCamera',
  'clarity',
  'videoDuration',
  'recordDuration',
  'evidenceQuality',
  'evidenceType',
  'imageRecognitionType',
  'takePhotoAuxiliaryLine',
  'forcePanorama',
  'allowReusePhoto',
  'allowCrossSubjectRecord',
  'reportedTablesAssociationStepId'
]

const hasEvidenceFields = [
  'takePhotoScene', // 2022-07-13 新增拍照场景（陈列分组拍摄），是 forcePanorama 字段的替代
]

export default {
  info: [
    ...basics,
    ...reusing,
    ...hasEvidenceFields,
    'dataLabel',
    'intelligentCall',
  ].sort(),
  text: [
    ...basics,
    ...reusing,
    ...hasEvidenceFields,
    'inputType',
    'inputMin',
    'inputMax',
    'dataLabel',
    'intelligentCall',
  ].sort(),
  multitext: [
    ...basics,
    'referStepId',
    'referIds',
    'mtext',
    'intelligentCall',
  ].sort(),
  multiselect: [
    ...basics,
    ...reusing,
    ...hasEvidenceFields,
    'moptions',
    'conditional_jump',
  ].sort(),
  imageMultiselect: [
    ...basics,
    ...reusing,
    ...hasEvidenceFields,
    'pictureMultipleOptions',
    'conditional_jump',
  ].sort(),
  select: [
    ...basics,
    ...hasEvidenceFields,
    'clarity',
    'videoDuration',
    'recordDuration',
    'evidenceQuality',
    'evidenceType',
    'imageRecognitionType',
    'allowReusePhoto',
    'allowCrossSubjectRecord',
    'conditional_jump',
    'options',
    'dataLabel',
    'reportedTablesAssociationStepId'
  ].sort(),
}



// WEBPACK FOOTER //
// ./src/views/question-editor/format/recovery-fields/question-types.js